import React, { useState } from "react";
import { ModalBuilder, Modal, Lookup } from "@redriver/cinnamon";
import { PermissionCheck } from "features/../../../shared/components/auth";
import {
  Actions,
  Targets,
} from "features/../../../shared/constants/permissions";
import { IconButton } from "features/../../../shared/components/buttons";
import Add from "features/../../../shared/assets/white-add.svg";
import { LookupTypes } from "features/../../../shared/features/Settings";
import MeteredServiceForm from "./MeteredServiceForm";

const AddMeteredServiceModal = ({
  submitAction,
  onSubmitted,
  dealerOfficeId,
}) => {
  const [uploadDoc, setUploadDoc] = useState(null);

  const onChangeUpload = (file) => {
    let fileReader = new FileReader();
    fileReader.onload = () => {
      const res = fileReader.result;
      setUploadDoc(res);
    };
    fileReader.readAsDataURL(file);
  };
  return (
    <PermissionCheck target={Targets.Service} action={Actions.Create}>
      <ModalBuilder
        withForm
        submitAction={submitAction}
        submitParams={{ dealerOfficeId, uploadDoc }}
        onSubmitted={onSubmitted}
        renderTrigger={(showModal) => (
          <IconButton
            icon={Add}
            primary
            content="New Metered Service"
            onClick={showModal}
          />
        )}
        renderModal={(modalProps, formProps) => (
          <Modal.Add
            {...modalProps}
            size="small"
            header="Add Metered Service"
            submitLabel="Create Metered Service"
          >
            <MeteredServiceForm
              formProps={formProps}
              dealerOfficeId={dealerOfficeId}
              onChangeUpload={onChangeUpload}
            />
          </Modal.Add>
        )}
      />
    </PermissionCheck>
  );
};

export default AddMeteredServiceModal;
